module.exports = __webpack_public_path__ + "de7ef31e6295902347c5c3643b2d82da.ttf";